<template>
  <div class="d-flex flex-column align-items-center">
    <div class='main-content'>
      <!-- <content-header title="Player Registration" /> -->
      <el-steps :active="step" align-center finish-status="success" class="d-flex justify-content-center">
        <el-step v-show="!registration.isBulk" title="Member Details"></el-step>
        <el-step v-show="hasAdditionalQs > 0" title="Additional Questions"></el-step>
        <el-step v-show="hasSubProducts " title="Sub Product Selection"></el-step>
        <el-step title="Store"></el-step>
      </el-steps>
      <content-body-card>
        <player-details v-if="step === 0 && !registration.isBulk" :editing="editing" :memberId="memberId" :event="selectedEvent" :editingRego="editingRego" @update-step="updateStep" @tc-update="updateButtonStatus" ref="rego"/>
        <additional-questions v-if="step === 1" :editing="editing" :value="registration" @update-step="updateStep" ref="rego"/>
        <sub-products v-if="step === 2" :editing="editing" :value="registration" @update-step="updateStep" ref="rego"/>
        <store v-if="step === 3" :editing="editing" :value="registration" @update-step="updateStep" ref="rego" @update-store="updateButtonStatus"/>
        <el-row class="mt-10">
          <el-divider></el-divider>
          <el-row :span="24" class="d-flex mt-10" :gutter="20">
            <el-col :span="12" class="d-flex justify-content-end">
              <el-button class="bottomBtn" @click="back">Back</el-button>
            </el-col>
            <el-col :span="12">
              <el-button type="primary" :class="isNextDisabled ? 'bottomBtn disabled-next' : 'btn-highlight bottomBtn'" @click.prevent="next" :disabled="isNextDisabled">
                Next
              </el-button>
            </el-col>
          </el-row>
        </el-row>
      </content-body-card>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import PlayerDetails from './1-PlayerDetails.vue';
import AdditionalQuestions from './2-AdditionalQuestions.vue';
import Store from './4-Store.vue';
import SubProducts from './3-SubProducts.vue';

export default {
  name: 'RegisterIndividualToTeam',
  components: {
    PlayerDetails,
    AdditionalQuestions,
    Store,
    SubProducts
  },
  props: {
    criteria: String,
    memberId: Number,
    selectedEvent: Object,
    editing: Boolean,
    editingRego: Object
  },
  data() {
    return {
      step: 0,
      registration: {
        entityType: undefined,
        entityId: undefined,
        memberId: undefined,
        profile: undefined,
        productType: undefined,
        memberType: undefined,
        tags: undefined,
        product: undefined,
        additionalQs: undefined,
        saleableItems: undefined,
        subProducts: undefined,

        discounts: undefined,
        acceptActiveKids: undefined,
        meta: undefined,
        team: undefined,
        isTCRequired: false,
        isTCAccepted: false
      },
      isNextDisabled: true,
      isTCAccepted: false
    };
  },
  mounted() {
    const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
    if (!this.memberId) this.$router.push({ name: pathName });
  },
  methods: {
    updateButtonStatus(status) {
      this.isNextDisabled = status;
      this.isTCAccepted = !status;
    },
    async updateStep(val, step = 1) {
      _.assign(this.registration, val);
      if (step > 0) {
        if (this.step === 0 && !this.hasAdditionalQs) this.step += 1;
        if (this.step === 1 && !this.hasSubProducts) this.step += 1;

        if (this.step === 2 && !this.hasSaleableItems) this.step += 1;
      }
      if (step < 0) {
        if (this.step === 3 && !this.hasSubProducts) this.step -= 1;
        if (this.step === 2 && !this.hasAdditionalQs) this.step -= 1;
      }

      if (this.step === 3 && step === 1) {
        if (_.get(this.registration, 'product.customFees.required') && _.get(this.registration, 'product.customFees.isFixedValue') === false && _.get(this.registration, 'product.customFees.value') === 0) {
          try {
            // eslint-disable-next-line no-await-in-loop
            await this.$confirm(`Would you like to contribute for ${_.get(this.registration, 'product.name', '') !== '' ? this.registration.product.name : this.registration.entityName}`, `${this.registration.product.customFees.label}`, {
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
              type: 'warning'
            });

            // eslint-disable-next-line no-await-in-loop
            const donationResponse = await this.$prompt('Please enter the amount you would like to contribute', `${this.registration.product.customFees.label}`, {
              confirmButtonText: 'Confirm',
              cancelButtonText: 'Cancel',
              inputPattern: /\d+/,
              inputErrorMessage: 'Please enter a valid number'
            });

            // eslint-disable-next-line no-param-reassign
            this.registration.product.customFees.value = parseInt(donationResponse.value) * 100;
          } catch (err) {
            console.log(err);
          }
        }
        // Final step - add to cart
        this.$confirm('Do you want to perform another registration?', 'Confirm', {
          distinguishCancelAndClose: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
        }).then(() => {
          if (this.editing) this.$store.commit('cart/edit', this.registration);
          else {
            this.$store.commit('cart/add', this.registration);
          }
          const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
          this.$router.push({ name: pathName });
        }).catch((action) => {
          if (action === 'cancel') {
            if (this.editing) this.$store.commit('cart/edit', this.registration);
            else {
              this.$store.commit('cart/add', this.registration);
            }
            const pathName = this.hasCustomEntity ? 'custom-payment' : 'payment';
            this.$router.push({ name: pathName });
          }
        });
      } else this.step += step;
    },
    cancel() {
      const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
      this.$router.push({ name: pathName, params: { defaultCriteria: this.criteria } });
    },
    back() {
      if (this.step === 0) {
        console.log('pendingRegistration', this.pendingRegistration);
        // push with query params
        const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
        this.$router.push({
          name: pathName,
          params: { pendingRegistration: this.pendingRegistration, defaultCriteria: this.criteria },
        });
      } else this.$refs.rego.updateStep(-1);
    },
    next() {
      this.$refs.rego.updateStep(1);
    }
  },
  computed: {
    ...mapGetters('cart', ['pendingRegistration']),
    hasCustomEntity() {
      const customEntity = this.$store.getters['national/getEntity'];
      if (customEntity && customEntity.level && customEntity.name) {
        return true;
      }
      return false;
    },
    hasAdditionalQs() {
      return this.registration.additionalQs && this.registration.additionalQs.length;
    },
    hasSaleableItems() {
      return this.registration.saleableItems && this.registration.saleableItems.length;
    },
    hasSubProducts() {
      return this.registration && this.registration.product && this.registration.product.hasSubProducts && this.registration.product.subProducts && this.registration.product.subProducts.length;
    }
  }
};
</script>

<style scoped lang="scss">
.main-content {
  width: 90%;
  max-width: $md;

  // .content-body {
  //   width: 100%;
  // }

  .bottomBtn {
    max-width: 100%;
    width: 12em;
  }

  .disabled-next {
    background: rgba($highlight, 0.7);
    border: 0 !important;
    cursor: pointer !important;
  }
}
</style>
